export default __webpack_public_path__ + "static/media/group-3-one-nfl.1b49e355.png";